.groups {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-lg);
}

.group {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
}

.groupTitle {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.handlingChargeValue {
  font-size: var(--mantine-font-size-sm);
}

.measurementRow {
  display: flex;
  border: 1px solid var(--adl-border-light);
  border-radius: var(--mantine-radius-sm);
  overflow: hidden;
}

.measurementRow > * {
  flex: 1;
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
}

.measurementRow > *:not(:last-child) {
  border-right: 1px solid var(--adl-border-light);
}

.referencesList {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
}

.referenceRow {
  display: flex;
  gap: var(--mantine-spacing-sm);
  font-size: var(--mantine-font-size-sm);
}

.referenceType {
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.referenceType::after {
  content: ':';
}
